import {
  ChargingStation,
  linkChargingStation,
  searchChargingStations
} from '@infuse/api/e-connector/charging-station';
import { equals } from '@infuse/api/common';

import {
  CentralSystem,
  ConnectionType,
  LinkedCentralSystemType,
  OcppVersion
} from '@infuse/e-connector/central-system/domain';
import { createChargingStation } from '@infuse/api/e-connector/charging-station';
import { BasicAuthStatus, normalizeChargingStationForApi } from '@infuse/e-connector/charging-station/domain';

export const useCreateChargingStation = () => {
  async function chargePointExistsInEconnector(cpName: string): Promise<boolean> {
    try {
      const response = await searchChargingStations({
        size: 1,
        filter: equals('name', cpName)
      });
      return (response.content?.length ?? 0) > 0;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async function createStationInEconnector(id: string): Promise<ChargingStation> {
    const chargePointWithDefaults = {
      name: id,
      type: ConnectionType.WEBSOCKET,
      ocppVersion: OcppVersion.V16,
      useManualURI: false,
      useRequestHeader: false,
      omitSoapHeader: false,
      basicAuthStatus: BasicAuthStatus.NOT_REQUIRED,
      networkProfileId: 1
    };

    const chargePoint = await createChargingStation({}, normalizeChargingStationForApi(chargePointWithDefaults));
    return chargePoint as ChargingStation;
  }

  async function addDefaultLinkedCentralSystem(
    econnectorStation: ChargingStation,
    centralSystem: CentralSystem
  ): Promise<void> {
    const linkedCentralSystem = {
      id: econnectorStation.id,
      centralStationName: centralSystem.name,
      centralSystemName: centralSystem.name,
      link: true,
      type: LinkedCentralSystemType.MASTER,
      commandsAllowed: true,
      forwardBasicAuth: false,
      sessionAuthorizationAllowed: false
    };

    await linkChargingStation({ id: econnectorStation.id }, linkedCentralSystem);
  }

  return {
    chargePointExistsInEconnector,
    createStationInEconnector,
    addDefaultLinkedCentralSystem
  };
};
